import React, { useState } from "react";
import Layouts from "../../Components/Layouts/Layouts";
import axios from "../../axiosinstens";
import swal from "sweetalert";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSendCode = async () => {
    if (!email) {
      alert("Please enter your email.");
      return;
    }

    try {
      await axios.post("organiserSendCode", { email: email });
      swal("Success", "Verification code sent to your email.", "success");
    } catch (error) {
      swal(
        "Error",
        "Failed to send verification code. Please try again.",
        "error"
      );
    }
  };

  const handleResetPassword = async () => {
    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      const response = await axios.post("organiserResetPassword", {
        email: email, // Email of user
        verificationCode: verificationCode, // Code entered by user
        newPassword: newPassword, // New password to set
      });

      if (response.data.success) {
        swal("Success", "Password reset successful!", "success");

        window.location.href = "/login";
      } else {
        swal(
          "Error",
          "Failed to reset password: " + response.data.message,
          "error"
        );
      }
    } catch (error) {
      swal("Error", "An error occurred while resetting password.", "error");
    }
  };

  return (
    <Layouts>
      <section className="login">
        <div className="log-form">
          {/* Left Side: Verification Code & New Password */}
          <div className="logfrmm">
            <div className="loggfrm">
              <h2>Reset Your Password</h2>
              <input
                type="text"
                placeholder="Verification Code"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
              />
              <input
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <input
                type="password"
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button className="loggfrmButton" onClick={handleResetPassword}>
                Reset Password
              </button>
            </div>
          </div>

          {/* Line Separator */}
          <div className="linehight">
            <div className="lineimg">
              <img src="assets/images/contact/line.png" alt="line" />
            </div>
          </div>

          {/* Right Side: Send Verification Code */}
          <div className="logfrmm">
            <div className="loggfrm">
              <h2>Forgot Password?</h2>
              <p style={{ textAlign: "center" }}>
                Enter your email to receive a verification code.
              </p>
              <input
                type="email"
                placeholder="Enter your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button className="loggfrmButton" onClick={handleSendCode}>
                Send Code
              </button>
            </div>
          </div>
        </div>
      </section>
    </Layouts>
  );
}

export default ForgotPassword;
